import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Camera } from "lucide-react";

const DEMO_ACCOUNTS = [
  { email: "admin@grippelrental.com", label: "Super Admin" },
  { email: "sales@grippelrental.com", label: "Sales" },
  { email: "booking@grippelrental.com", label: "Booking Admin" },
  { email: "warehouse@grippelrental.com", label: "Warehouse" },
  { email: "finance@grippelrental.com", label: "Finance" },
];

export default function LoginPage() {
  const { login, formatApiError, user } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@grippelrental.com");
  const [password, setPassword] = useState("Grippel123!");
  const [busy, setBusy] = useState(false);

  React.useEffect(() => { if (user) nav("/"); }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Selamat datang di Grippel RMS");
      nav("/");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-white">
      <div className="hidden lg:flex flex-col justify-between p-10 bg-neutral-950 text-white relative overflow-hidden">
        <div className="flex items-center gap-2">
          <div className="h-8 w-8 rounded-md bg-green-600 flex items-center justify-center">
            <Camera className="h-4 w-4" />
          </div>
          <div className="font-bold tracking-tight text-lg" style={{ fontFamily: "Manrope, sans-serif" }}>Grippel Rental</div>
        </div>
        <div>
          <div className="text-3xl font-bold tracking-tight leading-tight mb-3" style={{ fontFamily: "Manrope, sans-serif" }}>
            Sistem Manajemen Rental Equipment Produksi
          </div>
          <div className="text-sm text-neutral-400 max-w-md">
            Kelola inventory, booking, quotation, invoice, dan operasional gudang untuk bisnis rental camera, lighting,
            grip, gimbal, monitor, wireless video, dan audio di Jabodetabek.
          </div>
        </div>
        <div className="text-xs text-neutral-500">© {new Date().getFullYear()} Grippel Rental · www.grippelrental.com</div>
      </div>

      <div className="flex items-center justify-center p-6">
        <div className="w-full max-w-sm">
          <div className="mb-6">
            <h1 className="text-2xl font-bold tracking-tight" style={{ fontFamily: "Manrope, sans-serif" }}>Masuk ke Akun</h1>
            <p className="text-sm text-neutral-500 mt-1">Gunakan email dan password akun Anda.</p>
          </div>
          <form onSubmit={submit} className="space-y-4" data-testid="login-form">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input
                id="email" type="email" value={email}
                onChange={(e) => setEmail(e.target.value)} required autoFocus
                data-testid="login-email"
              />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input
                id="password" type="password" value={password}
                onChange={(e) => setPassword(e.target.value)} required
                data-testid="login-password"
              />
            </div>
            <Button
              type="submit" className="w-full bg-green-600 hover:bg-green-700"
              disabled={busy} data-testid="login-submit"
            >
              {busy ? "Memproses…" : "Masuk"}
            </Button>
          </form>
          <div className="mt-6 border-t border-neutral-200 pt-4">
            <div className="text-xs uppercase tracking-wider text-neutral-500 mb-2">Akun Demo (password: Grippel123!)</div>
            <div className="grid grid-cols-1 gap-1">
              {DEMO_ACCOUNTS.map((a) => (
                <button
                  key={a.email}
                  type="button"
                  onClick={() => { setEmail(a.email); setPassword("Grippel123!"); }}
                  className="text-left text-xs px-2 py-1.5 rounded border border-neutral-200 hover:border-green-600 hover:bg-green-50 transition-colors"
                  data-testid={`demo-account-${a.label.toLowerCase().replace(/\s/g, "-")}`}
                >
                  <span className="font-medium">{a.label}</span> · <span className="text-neutral-500">{a.email}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
